import { render, staticRenderFns } from "./BBConciliation.vue?vue&type=template&id=2dc6d1a5&scoped=true&lang=pug"
import script from "./BBConciliation.vue?vue&type=script&lang=js"
export * from "./BBConciliation.vue?vue&type=script&lang=js"
import style0 from "./BBConciliation.vue?vue&type=style&index=0&id=2dc6d1a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc6d1a5",
  null
  
)

export default component.exports